// src/layout/UserMenu.jsx
//
// Topbar user avatar + dropdown. "Sign out" is wired to the real
// logout flow (same as the old header: POST /auth/logout to clear the
// shared google_id_token cookie, then clearSession + redirect). "My
// profile" / "Preferences" have no pages yet, so they're shown disabled
// with a "Soon" tag rather than linking nowhere.

import PropTypes from "prop-types";
import { User, Settings, LogOut, ChevronDown } from "lucide-react";

function initialsOf(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default function UserMenu({ open, onToggle, username, role, onLogout }) {
  return (
    <div style={{ position: "relative" }}>
      <button type="button" className="orion-user-btn" onClick={onToggle}>
        <div className="orion-avatar-md">{initialsOf(username)}</div>
        <div className="orion-user-meta">
          <div className="n">{username}</div>
          <div className="r">{role || "—"}</div>
        </div>
        <ChevronDown size={15} color="var(--jade-neutral-500)" />
      </button>

      {open && (
        <div className="orion-dropmenu" style={{ width: 220, right: 0, left: "auto", top: 50, padding: 6 }}>
          <button type="button" className="orion-drop-row disabled" style={{ borderRadius: 8 }} disabled>
            <User size={16} />
            <div className="meta"><div className="t">My profile</div></div>
            <span className="orion-soon-tag" style={{ color: "var(--jade-neutral-500)", borderColor: "var(--jade-neutral-200)" }}>Soon</span>
          </button>
          <button type="button" className="orion-drop-row disabled" style={{ borderRadius: 8 }} disabled>
            <Settings size={16} />
            <div className="meta"><div className="t">Preferences</div></div>
            <span className="orion-soon-tag" style={{ color: "var(--jade-neutral-500)", borderColor: "var(--jade-neutral-200)" }}>Soon</span>
          </button>
          <button
            type="button"
            className="orion-drop-row"
            style={{ borderRadius: 8, color: "var(--jade-danger-700)" }}
            onClick={onLogout}
          >
            <LogOut size={16} />
            <div className="meta"><div className="t" style={{ color: "var(--jade-danger-700)" }}>Sign out</div></div>
          </button>
        </div>
      )}
    </div>
  );
}
UserMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  role: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
};
